import { useColor } from '../../components/useColor'

export default function pinCustomColor(primary, type) {
  return `
    <svg
      width="36.171"
      height="43.359"
      viewBox="0 0 36.171 43.359"
    >
      <defs>
        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="${primary}" />
          <stop offset="1" stop-color="${type === 'gradient' ? useColor(primary, -30) : primary}" />
        </linearGradient>
        <filter id="Caminho_47" x="0" y="0" width="36.171" height="43.359" filterUnits="userSpaceOnUse">
          <feOffset dx="-1" dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Caminho_47)">
        <path
          id="Caminho_47-2"
          data-name="Caminho 47"
          d="M223.7,353.332l-.006,0a11.951,11.951,0,0,0,1.064-4.919,12.086,12.086,0,0,0-24.171,0,11.957,11.957,0,0,0,.741,4.113.01.01,0,0,0-.005,0c.012.031.028.061.04.092a11.956,11.956,0,0,0,.774,1.677c2.792,5.494,8.249,11.247,10.089,13.139a.833.833,0,0,0,.488.278.858.858,0,0,0,.469-.247c1.2-1.215,7.154-7.49,10.107-13.305C223.309,354.122,223.588,353.566,223.7,353.332Zm-11.028-9.542c5.115,0,5.158,7.458.042,7.458S207.552,343.79,212.669,343.79Z"
          transform="translate(-193.58 -332.35)"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  `
}
